import { useEffect } from 'react';
import { fetchServerCart } from '../slices/cartSlice';

// Fetches the server cart after a non-guest user logs in. Keyed on the
// stable identity fields, not the userInfo object itself — userInfo gets a
// new reference on every silent access-token refresh (setAccessToken
// spreads it), which would otherwise re-fire this on every refresh, not
// just login, and could overwrite a cart edit made seconds earlier with
// stale server data.
export default function useSyncCartOnLogin(userInfo, dispatch) {
  useEffect(() => {
    if (userInfo && !userInfo.isGuest) {
      dispatch && dispatch(fetchServerCart());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?._id, userInfo?.isGuest, dispatch]);
}
